import { render } from "./WhatsAppBtn.vue?vue&type=template&id=76f014a5"
import script from "./WhatsAppBtn.vue?vue&type=script&lang=js"
export * from "./WhatsAppBtn.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__